export const blockIconsHomeNestCamOutdoorNew = (
	<span className='material-symbols-outlined'>nest_cam_outdoor</span>
);
